module.exports = __webpack_public_path__ + "41cdf6c3556a68a4ad210e6093ce163c.png";